import { artifact_list_item } from "@/app/typing/artifacts";
import { useEffect, useRef, useState } from "react";
import { ChatEntryList } from "./chatEntryList";
import { adminDeleteArtifacts } from "@/api";
import { scrollIntoContainer } from "@/components/scrollUtils";

const ChatArtifactList = (params: { artifacts: artifact_list_item[], tool_use_id?: string, intent?: string }) => {

    const containerRef = useRef<HTMLDivElement>(null);
    const [highlightedId, setHighlightedId] = useState<number | null>(null);

    useEffect(() => {
        const handleCitationHover = (e: CustomEvent) => {


            if (e.detail.citationType == "artifact") {
                const { artifact_id, action } = e.detail;

                if (action === 'enter') {
                    setHighlightedId(artifact_id);
                } else if (action === 'leave') {
                    setHighlightedId(null);
                }

            }
        };

        const handleCitationClick = (e: CustomEvent) => {

            const { artifact_id } = e.detail;

            if (e.detail.citationType == "artifact") {

                const element = containerRef.current?.querySelector(`[data-item-id="${artifact_id}"]`);
                if (element) {
                    setHighlightedId(artifact_id);
                    setTimeout(() => element.scrollIntoView({ behavior: 'smooth', block: 'center' }), 100);
                }

            }

        };

        document.addEventListener('citation-hover', handleCitationHover as EventListener);
        document.addEventListener('citation-click', handleCitationClick as EventListener);

        return () => {
            document.removeEventListener('citation-hover', handleCitationHover as EventListener);
            document.removeEventListener('citation-click', handleCitationClick as EventListener);
        };
    }, [params.tool_use_id]);

    return (
        <div className="w-full" id="artifact" ref={containerRef}>
            <ChatEntryList
                items={params.artifacts}
                object_type={`artifact`}
                intent={params.intent}
                extractDisplayValue={(artifact) => artifact.variable_name}
                extractId={(artifact) => artifact.id}
                deleteFunction={(ids) => adminDeleteArtifacts({ body: { ids } })}
                routePath="/workspace/artifacts"
                highlightedId={highlightedId}
            />
        </div>
    );
};


export default ChatArtifactList